import getMuiTheme from 'material-ui/styles/getMuiTheme';
import COLORS from './colors';

const teamhubTheme = {
  palette: {
    primary1Color: COLORS.turquoise,
  },
};

export default getMuiTheme(teamhubTheme);



// WEBPACK FOOTER //
// ./src/theme/teamhub_theme.js